export function replaceHost (url) {
    return url && url.replace(new URL(url).host, window.location.host);
}
